// extracted by mini-css-extract-plugin
export default {"buttonStyle":"CustomButtonBlueBg_buttonStyle__jLvA3"};